export const RATE_TYPE_GENERAL = 'general';
export const RATE_TYPE_EACH_DAY = 'each_day';

export const RATE_PERIOD_TYPE_DAY = 'day';
export const RATE_PERIOD_TYPE_HALF_DAY = 'half_day';
export const RATE_PERIOD_TYPE_HOUR = 'hour';
export const RATE_PERIOD_TYPE_FLAT = 'flat';